import Model from '~/models/base/Model';

/**
 * class representing hash file
 * @extends Model
 * @author fm
 */
export default class File extends Model {
    static save(params) {
        const requestPayload = params || {};
        requestPayload.op_type = 'insert_hash_artifact';
        const id = requestPayload.incident_id;
        const requestUrl = `${APP_URL.api}/${
            id !== undefined ? `incidents/${id}/objects` : 'entities'
        }/file/`;
        return this.api.post(requestUrl, requestPayload);
    }

    static saveWFile(id, params) {
        const requestPayload = params ?? {};
        const requestUrl = `${APP_URL.api}/${
            id !== undefined ? `incidents/${id}/objects` : 'entities'
        }/file/`;
        return this.api.post(requestUrl, requestPayload);
    }
}
